import { createContext, useMemo, type PropsWithChildren } from 'react'

export interface AppBarContextProps {
  onLogout?: () => void
  toCartPage?: () => void
  isCartDisabled?: boolean
  environment?: 'campaign' | 'merchant' | 'wordPress'
}

export const AppBarContext = createContext<AppBarContextProps | null>(null)

export const AppBarProvider = (props: PropsWithChildren<AppBarContextProps>) => {
  const { children, onLogout, isCartDisabled, toCartPage, environment } = props

  const contextValue = useMemo(
    () => ({
      onLogout,
      isCartDisabled,
      toCartPage,
      environment,
    }),
    [isCartDisabled, onLogout, toCartPage, environment],
  )

  return (
    <AppBarContext.Provider value={contextValue}>
      {children}
    </AppBarContext.Provider>
  )
}
